var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"hero"},[_c('meeting-card',{attrs:{"todos":_vm.params.todos,"mission":_vm.params.mission}}),_c('news-card',{attrs:{"news":_vm.params.news}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }